import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const KidsPlanSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section title={t('dutyHourTypes.section.kidsPlan')}>
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="INCLUDE_IN_KIDS_RATIO"
        label={t('dutyHourTypes.fieldName.includeInKidsRatio')}
      />
    </MultiStepForm.Section>
  );
};
